// import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import TextArea from './components/TextArea';
import React,{useState} from 'react';
import Alert from './components/Alert';


function App() {
  const [mode, setMode] = useState("light");
 
  
  const [alert,setAlert] = useState(null);

  const showAlert=(message,type)=>{
    setAlert(
      {
        message:message,
        type:type
      },
      setTimeout(() => {
        setAlert(null)
      }, 1500)
    )
  }

  const toggleMode=()=>{
    if(mode==="light"){
      setMode("dark");
      document.body.style.backgroundColor='#282A3A';
      showAlert("Dark mode Enabled","success");
      document.title="textUtils - Dark Mode";
    }else{
      setMode("light");
      document.body.style.backgroundColor='white';
      showAlert("Light mode Enabled","success");
      document.title="textUtils - Light Mode";
    }
  }
 

  return (
    <>

      <Navbar title="textUtils" mode={mode} toggleMode={toggleMode}/>
      <Alert alert={alert}/>
        <div className="container my-3" >
            <TextArea showAlert={showAlert} heading="Enter text to analyze" alert={alert} mode={mode}/>
        </div>

    </>
  );
}

export default App;
